import { Preview } from "../../../types/IAction";
import {
  postReporteSimulacionCierre,
  getHistorialReporteSimulacion
} from "../../actions/reports";

export interface PrecalculoDispatcher {
  postReporteSimulacionCierre: () => Promise<Preview<any>>;
  getHistorialReporteSimulacion: (
    page: number,
    size: number
  ) => Promise<Preview<any>>;
}

export const precalculoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => PrecalculoDispatcher = dispatch => ({
  postReporteSimulacionCierre: () => {
    return dispatch(postReporteSimulacionCierre());
  },
  getHistorialReporteSimulacion: (page: number, size: number) => {
    return dispatch(getHistorialReporteSimulacion(page, size));
  }
});
